import dayjs from 'dayjs';
import { ContractState, convertCurrencyToSign } from '@received/pricing-model';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Cell, LogoCell, StatusCol } from '../../../components/_uiComponents/Table/Table.utils';
import { DATE_FORMAT } from '../../../constants/templateConstants';
import { getValueWithCurrencySign } from '../../../utils/NumberUtils';
import { ContractView } from '../../../types/contractTypes';
import { contractStateColor } from '../../../components/_customerTabs/ContractsTab/ContractsTab.utils';
import { contractIdFormat } from '../../../utils/ContractUtils';
import styles from './EnterprisesContracts.module.scss';

export const enterprisesContractsHeader = (tableSmallRowsView: boolean, t: any) => [
	{
		headerTitle: 'customer',
		accessor: 'customerName',
		isSortable: true,
		CustomComponent: (item: ContractView) =>
			tableSmallRowsView ? <Cell accessor={item?.customerName} /> : <LogoCell title={item.customerName} logoData={item.iconData} />,
	},
	{
		headerTitle: 'contract',
		accessor: 'contract',
		CustomComponent: (item: ContractView) => <Cell accessor={contractIdFormat(item?.poNumber, item?.contractNumber)} subAccessor={item?.name} />,
	},
	{
		headerTitle: 'products',
		accessor: 'productName',
		CustomComponent: (item: ContractView) => {
			const { t } = useTranslation('translation');
			const accessor = item?.productName || '';
			const subAccessor = +item?.productCount > 1 ? `+${item?.productCount - 1} ${t(item?.productCount > 2 ? 'Products' : 'product')}` : '';
			return <Cell accessor={accessor} subAccessor={subAccessor} />;
		},
	},
	{
		headerTitle: 'paid',
		accessor: 'totalPayments',
		CustomComponent: (item: ContractView) => {
			return <Cell accessor={item.totalPayments ? `${getValueWithCurrencySign(item.totalPayments, convertCurrencyToSign(item.currency))}` : '-'} />;
		},
	},
	{
		headerTitle: 'nextInvoice',
		accessor: 'nextInvoiceAmount',
		CustomComponent: (item: ContractView) => (
			<Cell
				accessor={item.nextInvoiceAmount ? `${getValueWithCurrencySign(item.nextInvoiceAmount, convertCurrencyToSign(item.currency))}` : '-'}
				subAccessor={item.nextInvoiceDate ? dayjs(item.nextInvoiceDate).format(DATE_FORMAT) : ''}
			/>
		),
	},
	{
		headerTitle: 'lastEdit',
		accessor: 'lastEdit',
		CustomComponent: (item: ContractView) => <Cell accessor={dayjs(item?.lastEdit).format(DATE_FORMAT)} />,
	},
	{
		headerTitle: 'status',
		accessor: 'state',
		isSortable: true,
		CustomComponent: (item: ContractView) => {
			const badgeColor = contractStateColor(item);
			return (
				<StatusCol color={badgeColor.color} className={clsx(item?.state == ContractState.END_BILLING && styles.contractEndBillingBadge)}>
					{badgeColor.text}
				</StatusCol>
			);
		},
	},
];
